import { useContext } from "react";
import AuthenticatedLayout from "./AuthenticatedLayout";
import Layout from "./Layout";
import { AuthContext } from "../context/AuthContext";

const ConditionalLayout = (props) => {
  const { isAuthenticated } = useContext(AuthContext);

  return (
    <>
      {isAuthenticated ? (
        <AuthenticatedLayout>{props?.children}</AuthenticatedLayout>
      ) : (
        <Layout>{props?.children}</Layout>
      )}
    </>
  ); 
};

export default ConditionalLayout;
